import {useEffect, useState} from "react";
import {urlToObjectUrl} from "../photo_booth/utils";


export const usePossibleGridTargets = (
  {
    imageUrl,
    minBackgroundThreshold,
    maxBackgroundThreshold,
    gridWidth,
    gridHeight,
  }
) => {
  const [possibleTargets, setPossibleTargets] = useState(null)

  useEffect(() => {
    urlToObjectUrl(imageUrl).then(url => {
      const image = new Image();
      image.onerror = function (event) {
        alert(event)
      }
      image.onload = function () {
        const imageWidth = image.naturalWidth
        const imageHeight = image.naturalHeight

        const widthDiff = imageWidth / gridWidth
        const heightDiff = imageHeight / gridHeight

        const canvas = document.createElement("canvas")
        canvas.width = imageWidth
        canvas.height = imageHeight
        const ctx = canvas.getContext("2d", {willReadFrequently: true});
        ctx.drawImage(image, 0, 0, imageWidth, imageHeight);

        let possibleGridTargets = []
        for (let j = 0; j < gridHeight; j++) {
          for (let i = 0; i < gridWidth; i++) {
            const x = i * widthDiff
            const y = j * heightDiff
            const data = ctx.getImageData(x, y, widthDiff, heightDiff).data
              .filter((_, i) => i % 4 !== 3) // Filter all the alpha values
            const sum = data.reduce((partialSum, a) => partialSum + a, 0)
            const average = sum / data.length
            if (average >= minBackgroundThreshold && average <= maxBackgroundThreshold) {
              possibleGridTargets.push({
                row: j,
                column: i
              })
            }
          }
        }

        setPossibleTargets(possibleGridTargets)
      }
      image.src = url
    })
  }, [
    imageUrl,
    minBackgroundThreshold,
    maxBackgroundThreshold,
    gridWidth,
    gridHeight,
  ])

  return possibleTargets
}
